import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import api from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

export function Faq() {
  const [faqs, setFaqs] = useState([]);
  const { t } = useLang();

  useEffect(() => {
    api.get("/faqs").then(({ data }) => setFaqs(data)).catch(() => {});
  }, []);

  return (
    <section id="faq" data-testid="faq-section" className="relative z-10 bg-[#0a0a0a] py-24 md:py-36 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{t("faq.overline")}</span>
          <h2 className="font-display font-bold tracking-[-0.02em] text-white text-4xl md:text-5xl mt-5 leading-[1.03] lg:sticky lg:top-28">
            {t("faq.heading")}
          </h2>
        </Reveal>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f) => (
              <AccordionItem key={f.id} value={f.id} className="border-b border-white/10">
                <AccordionTrigger data-testid={`faq-q-${f.id}`} className="text-start font-display text-lg md:text-xl font-medium text-white hover:no-underline py-6">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-base leading-relaxed pb-6 max-w-2xl">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
